import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { getLegacyFontStyles } from "pages/Home/HomeStyles";
import { PropsWithChildren } from "react";

export const SectionTitle = ({
  children,
  ...props
}: PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>>) => {
  return <Text {...props}>{children}</Text>;
};

// Sub-components

const Text = styled.h2(() => {
  const theme = useTheme();
  const legacyPrimaryFontStyle = getLegacyFontStyles(theme).primary;
  return {
    ...{ legacyPrimaryFontStyle },
    fontWeight: 500,
    lineHeight: 1.2,
    marginTop: "3rem",
    marginBottom: "24px",
    fontFamily: "quincy-cf",
    textAlign: "center",
    fontSize: "80px",
    maxWidth: "1540px",

    "@media screen and (min-width: 1280px) and (max-width: 1440px)": {
      fontSize: "56px",
      maxWidth: "1029px",
    },

    "@media screen and (min-width: 1024px) and (max-width: 1280px)": {
      fontSize: "40px",
      maxWidth: "646px",
    },

    "@media screen and (min-width: 769px) and (max-width: 1024px)": {
      fontSize: "40px",
      maxWidth: "807px",
    },

    "@media screen and (min-width: 390px) and (max-width: 768px)": {
      fontSize: "48px",
      maxWidth: "478px",
    },

    "@media screen and (max-width: 390px)": {
      fontSize: "32px",
      maxWidth: "85%",
    },
  };
});
